module.exports = __webpack_public_path__ + "img/FinanceIcon.2178c1da.svg";